export default "40b5a507ed456889.woff"